"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "section-time-block-name text-ellipsis" };
const vue_3 = require("vue");
const common_1 = require("../../common/common");
const models_1 = require("../../js/models");
const roleTimeLayout_1 = require("../roleTimeLayout");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionBlock',
    props: {
        roleSection: {},
        timeRange: {},
        laneIndex: {}
    },
    setup(__props) {
        const props = __props;
        const blockStyle = (0, vue_3.computed)(() => {
            const { start: timelineStart, end: timelineEnd } = props.timeRange;
            const { from, to, color } = props.roleSection;
            const slotStart = (0, common_1.kitchenTimeToDuration)(from || "", "minutes");
            const slotEnd = (0, common_1.kitchenTimeToDuration)(to || "", "minutes");
            const { start, end } = (0, roleTimeLayout_1.clampTimeSpanToTimeline)(slotStart, slotEnd, timelineStart, timelineEnd);
            const isDefaultColor = !color || color === models_1.OPLUS_COLOR_PALETTE.DEFAULT;
            return (0, roleTimeLayout_1.calculateTimelineBlockStyle)(start, end, timelineStart, timelineEnd, {
                laneIndex: props.laneIndex,
                background: !isDefaultColor ? `#${color}` : `#${models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: isDefaultColor ? "#3b4351" : "#fff",
            });
        });
        const isBlockVisible = (0, vue_3.computed)(() => {
            const { start: timelineStart, end: timelineEnd } = props.timeRange;
            const { from, to } = props.roleSection;
            const slotStart = (0, common_1.kitchenTimeToDuration)(from || "", "minutes");
            const slotEnd = (0, common_1.kitchenTimeToDuration)(to || "", "minutes");
            const { start, end } = (0, roleTimeLayout_1.clampTimeSpanToTimeline)(slotStart, slotEnd, timelineStart, timelineEnd);
            return (0, roleTimeLayout_1.isTimelineBlockVisible)(start, end, timelineStart, timelineEnd);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: (0, vue_2.normalizeClass)(["section-time-block", { 'is-hidden': !isBlockVisible.value }]),
                style: (0, vue_2.normalizeStyle)(blockStyle.value)
            }, [
                (0, vue_2.createElementVNode)("p", _hoisted_1, (0, vue_2.toDisplayString)(props.roleSection.name), 1 /* TEXT */)
            ], 6 /* CLASS, STYLE */));
        };
    }
});
